import { render, staticRenderFns } from "./SpentCashbackView.vue?vue&type=template&id=053cbbc4&"
import script from "@/scripts/spentCashback/spentCashbackView.js?vue&type=script&lang=js&"
export * from "@/scripts/spentCashback/spentCashbackView.js?vue&type=script&lang=js&"
import style0 from "./SpentCashbackView.vue?vue&type=style&index=0&id=053cbbc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports